import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, WritableSignal, inject, input, model } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";

import { CompleterLocationComponent } from "../../components/subscriptions-list/completer-location/completer-location";
import { FilterByStatus } from "../../components/subscriptions-list/filter-by-status/filter-by-status";
import { MessageService } from "../../services/messageservice";
import { NetworkServicesShortcutMenuComponent } from "./network-services-shortcut-menu";
import { SubscriptionsTagsFilterComponent } from "./subscriptions-tags-filter";

@Component({
  selector: "subscriptions-filter",
  templateUrl: "subscriptions-filter.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CompleterLocationComponent,
    FilterByStatus,
    FormsModule,
    NetworkServicesShortcutMenuComponent,
    SubscriptionsTagsFilterComponent,
    TranslatePipe,
  ],
})
export class SubscriptionsFilterComponent {
  private msgsrv = inject(MessageService);

  productType = input.required<string>();
  collectedTags = input.required<string[]>();
  collectedLocations = input.required<string[]>();

  activeFilters = model.required<string[]>();
  activeTags = model.required<string[]>();
  activeLocations = model.required<string[]>();
  servicesSearch = model.required<string>();

  constructor() {
    const filterMap: Partial<Record<string, WritableSignal<string[]>>> = {
      state: this.activeFilters,
      tag: this.activeTags,
      location: this.activeLocations,
    };

    this.msgsrv.enableFilter$.pipe(takeUntilDestroyed()).subscribe(({ type, value }) => {
      filterMap[type]?.update((values) => [...values, value]);
    });

    this.msgsrv.disableFilter$.pipe(takeUntilDestroyed()).subscribe(({ type, value }) => {
      filterMap[type]?.update((values) => values.filter((v) => v !== value));
    });
  }
}
